import { ComparisonPageTemplate } from "@/components/ComparisonPageTemplate";
import { Zap, Brain, Users } from "lucide-react";

const CSWvsStudioity = () => {
  return (
    <ComparisonPageTemplate
      platformName="Studiosity"
      platformUrl="https://studiosity.com"
      seoTitle="CSW vs Studiosity"
      seoDescription="Compare CSW and Studiosity for quizzes and worksheets. Discover why CSW is the best Studiosity alternative with free unlimited quizzes and collaborative study features."
      seoKeywords="CSW vs Studiosity, Studiosity alternative, free quizzes, study worksheets, online learning"
      canonicalUrl="https://csw.live/quizzes/csw-vs-studiosity/"
      heroDescription="Looking for free quizzes and worksheets for English, Math, and Science? Compare CSW and Studiosity for your study needs."
      alternativeDescription="CSW provides a comprehensive alternative to Studiosity with AI-powered quiz generation, unlimited practice tests, and collaborative study rooms—all completely free."
      background="Studiosity (formerly YourTutor) is an Australian education company that partners with universities and institutions to provide online writing feedback and live study help. It emphasises academic integrity, offering a commercialized alternative to essay‑writing services. Services include asynchronous writing feedback (personalized comments) and one‑to‑one chat with subject experts. Some universities provide it free to students; others require a subscription."
      pros={[
        { text: "Quick, personalized feedback – Student testimonials describe receiving thorough feedback on assignments that improved their work and confidence", source: "studiosity", sourceUrl: "https://studiosity.com" },
        { text: "Ethical alternative – The platform positions itself as supporting academic integrity by guiding students rather than writing for them", source: "cwcaaccr", sourceUrl: "https://cwcaaccr.com" },
        { text: "Partnerships with institutions – Integration with universities makes access easier for many students" },
      ]}
      cons={[
        { text: "Commercialized tutoring – Critics argue that outsourcing academic feedback commodifies academic support and may disadvantage students without access", source: "cwcaaccr", sourceUrl: "https://cwcaaccr.com" },
        { text: "Mismatch of expectations – Research shows students sometimes expect editors to 'fix' their writing rather than provide guidance", source: "researchgate", sourceUrl: "https://researchgate.net" },
        { text: "Limited subject coverage – Feedback focuses on writing and may not suit technical or highly specialized subjects" },
      ]}
      cswFeatures={[
        { text: "AI-powered quiz generation", available: true },
        { text: "All subjects supported", available: true },
        { text: "Collaborative study rooms", available: true },
        { text: "Free unlimited access", available: true },
        { text: "Productivity tools included", available: true },
        { text: "No institutional access required", available: true },
      ]}
      competitorFeatures={[
        { text: "Free quizzes & worksheets", available: true },
        { text: "Core subjects coverage", available: true },
        { text: "Often requires institution", available: false },
        { text: "No custom quiz creation", available: false },
        { text: "No study rooms", available: false },
        { text: "Limited AI features", available: false },
      ]}
      benefits={[
        { icon: Zap, title: "Instant Access", description: "No institution required. Start studying immediately." },
        { icon: Brain, title: "AI-Powered", description: "Generate quizzes on any topic from your notes." },
        { icon: Users, title: "Study Together", description: "Join virtual study rooms with other learners." },
      ]}
      forStudentsText="CSW covers all the subjects Studiosity offers—English, Math, Science—plus any other topic you need. Create custom quizzes from your own study materials instantly, no institutional access required."
      pricingText="Studiosity often requires institutional access or subscriptions. CSW gives everyone free unlimited access to AI-powered quizzes, study rooms, and productivity tools."
      competitorPrice="Institutional"
    />
  );
};

export default CSWvsStudioity;
